import React, {useEffect} from 'react';

const Page = (): JSX.Element => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  return (
    <iframe
      title="Stryd Terms of Use"
      src="https://drive.google.com/viewerng/viewer?embedded=true&url=https://storage.googleapis.com/stryd_static_assets/legal/stryd-terms-of-use-4-6-21.pdf"
      style={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        border: 'none',
        scrollBehavior: 'auto',
      }}
    />
  );
};

export default Page;
